import { Tooltip } from '@mantine/core';
import { DatePickerInput, type DatePickerInputProps } from '@mantine/dates';
import { useEffect, useState } from 'react';
import type { UseFilterReturn } from '../hooks/useFilter';

interface DateRangePickerProps extends DatePickerInputProps {
	filter: UseFilterReturn;
	isWeekly?: boolean;
}

export function DateRangePicker({
	filter,
	isWeekly = false,
	...dateRangeProps
}: DateRangePickerProps) {
	const [startDate, setStartDate] = useState<Date | null>(
		filter.value.startDate,
	);
	const [endDate, setEndDate] = useState<Date | null>(filter.value.endDate);

	useEffect(() => {
		if (startDate && endDate) {
			filter.setDateRange(startDate, endDate);
		}
	}, [startDate, endDate]);

	return (
		<>
			<Tooltip
				label={isWeekly ? 'Choose week start date...' : 'Filter start date...'}
			>
				<DatePickerInput
					placeholder={
						isWeekly ? 'Choose week start date...' : 'Choose start date...'
					}
					value={filter.value.startDate}
					onChange={(d) => setStartDate(new Date(d))}
					variant={dateRangeProps.variant}
					popoverProps={{ position: 'bottom' }}
				/>
			</Tooltip>
			<Tooltip
				label={isWeekly ? 'Choose week end date...' : 'Filter end date...'}
			>
				<DatePickerInput
					placeholder={
						isWeekly ? 'Choose week end date...' : 'Choose end date...'
					}
					value={filter.value.endDate}
					onChange={(d) => setEndDate(new Date(d))}
					variant={dateRangeProps.variant}
					popoverProps={{
						position: 'bottom-end',
					}}
				/>
			</Tooltip>
		</>
	);
}
